// src/components/purchases/AllocationProgressBar.tsx
// Displays allocation status for purchases - simple status badge

import React from 'react';

interface AllocationProgressBarProps {
  allocated: number;
  total: number;
  compact?: boolean;
}

const AllocationProgressBar: React.FC<AllocationProgressBarProps> = ({ 
  allocated, 
  total,
  compact = false 
}) => {
  // Ensure values are numbers (API may return strings)
  const allocatedNum = typeof allocated === 'string' ? parseInt(allocated, 10) : (allocated || 0);
  const totalNum = typeof total === 'string' ? parseInt(total, 10) : (total || 0);
  
  // Determine status
  const isComplete = allocatedNum >= totalNum && totalNum > 0;
  const isPartial = allocatedNum > 0 && allocatedNum < totalNum;

  if (isComplete) {
    return (
      <span className="px-2 py-1 text-xs font-medium bg-green-100 text-green-800 rounded-full">
        Complete
      </span>
    );
  }
  
  if (isPartial) {
    return (
      <span className="px-2 py-1 text-xs font-medium bg-yellow-100 text-yellow-800 rounded-full">
        Partial
      </span>
    );
  }
  
  return (
    <span className="px-2 py-1 text-xs font-medium bg-gray-100 text-gray-600 rounded-full">
      Pending
    </span>
  );
};

export default AllocationProgressBar;
